import { Card, Heading2, Heading3, P, SecondaryCTALink } from '@ovotech/nebula';
import { AnalyticsView, useAnalytics } from '@ovotech/ui-tools';
import React, { useEffect } from 'react';
import { PAYMENTS } from '@/src/constants/analytics';
import { ONE_CLICK_PAYMENT_REDUCTION_VIEW } from '@/src/constants/analytics-subjects';
import { DEBT_ASSISTANCE_URL } from '@/src/constants/links';

export default function OneClickPaymentReduction() {
  const { dispatch } = useAnalytics();

  useEffect(() => {
    dispatch({
      type: 'view',
      name: PAYMENTS.GET_SUPPORT_CTA_VIEWED,
    });
    // `dispatch` method is not  memoized and it causes useless  calls.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AnalyticsView name={ONE_CLICK_PAYMENT_REDUCTION_VIEW}>
      <Card data-testid="one-click-payment-reduction">
        <Heading2>Need help with your bills?</Heading2>
        <Heading3>Create a personalised payment plan</Heading3>
        <P>
          We can offer you a payment plan based on your personal circumstances.
          This could be making a one-off payment, or spreading the cost over
          time to make it more manageable.
        </P>
        <SecondaryCTALink
          href={DEBT_ASSISTANCE_URL}
          opensInNewWindow
          onClick={() => {
            dispatch({
              type: 'click',
              name: PAYMENTS.GET_SUPPORT_CTA_CLICKED,
            });
          }}
        >
          Get support
        </SecondaryCTALink>
      </Card>
    </AnalyticsView>
  );
}
